import { memo } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryMutualPairsList.module.scss";
import { MutualPair } from "shared/types/sociometry";

interface SociometryMutualPairsListProps {
    className?: string;
    pairs: MutualPair[];
}

export const SociometryMutualPairsList = memo((props: SociometryMutualPairsListProps) => {
    const { className, pairs } = props;
    if (!pairs.length) return <p>Взаимных выборов нет</p>;

    return (
        <div className={classNames(cls.sociometryMutualPairsList, {}, [className])}>
            {pairs.map((pair, idx) => (
                <div key={idx} className={cls.pair}>
                    <p>
                        {pair.pupilA.surname} {pair.pupilA.name}
                    </p>
                    <p>↔</p>
                    <p>
                        {pair.pupilB.surname} {pair.pupilB.name}
                    </p>
                    <p className={cls.type}>({pair.type === "positive" ? "Положительный" : "Отрицательный"})</p>
                </div>
            ))}
        </div>
    );
});

SociometryMutualPairsList.displayName = "SociometryMutualPairsList";
